import type { Toast } from '../types/toast';

export const generateToastId = (): string => {
	return Math.random().toString(36).substr(2, 9);
};

export const createToast = (toast: Omit<Toast, 'id'>): Toast => {
	return {
		id: generateToastId(),
		...toast,
	};
};
